export default [
  {
    path: "/live-list",
    component: (resolve) => require(["@/vuepage/live-manage/liveList.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "直播列表",
        activeRoute: "/live-list",
      },
    ],
  },
  {
    path: "/live-couse",
    component: (resolve) => require(["@/vuepage/live-manage/userPage.vue"], resolve),
    meta: [
      {
        name: "课程列表",
        activeRoute: "/live-couse",
      },
    ],
  },
  {
    path: "/add-live",
    component: (resolve) => require(["@/vuepage/live-manage/components/addLive.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "新增直播",
        activeRoute: "/live-list",
      },
    ],
  },
  {
    path: "/live-room",
    component: (resolve) => require(["@/vuepage/live-manage/roomList.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "房间列表",
        activeRoute: "/live-room",
      },
    ],
  },
  {
    path: "/live-pay",
    component: (resolve) => require(["@/vuepage/live-manage/payRecord.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "付费记录",
        activeRoute: "/live-pay",
      },
    ],
  },
  {
    path: "/watch-live",
    component: (resolve) => require(["@/vuepage/live-manage/components/watch.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "观看直播",
        activeRoute: "/live-room",
      },
    ],
  },
  {
    path: "/live-data",
    component: (resolve) => require(["@/vuepage/live-manage/components/data.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "数据",
        activeRoute: "/live-room",
      },
    ],
  },
  {
    path: "/order-detail",
    component: (resolve) => require(["@/vuepage/live-manage/components/orderDetail.vue"], resolve),
    meta: [
      {
        name: "直播管理",
      },
      {
        name: "订单详情",
        activeRoute: "/live-pay",
      },
    ],
  },
];
